import { HeartHandshake, Target, Telescope } from "lucide-react";
import React, { useEffect } from "react";


const MissionVision = () => {

 useEffect(() => {
  import("aos").then((AOS) => {
    AOS.default.init({
      duration: 500,
      easing: "ease-out-cubic",
      once: true,
      offset: 80,
    });
  });
}, []);

  return (
    <section className="py-10 bg-gradient-to-b lg:px-8 from-gray-800 to-gray-900 text-white">
      <div className="container mx-auto px-4 text-center">

        <h2
          className="text-2xl sm:text-3xl md:text-4xl xl:text-5xl font-extrabold mb-6"
          data-aos="fade-down"
        >
          Our{" "}
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-300">
            Mission & Vision
          </span>
        </h2>

        <p
          className="sm:text-lg text-[16px] text-gray-300 max-w-4xl mx-auto mb-12 leading-relaxed"
          data-aos="fade-up"
          data-aos-delay="150"
        >
          At <span className="text-blue-400 font-semibold">Game Zone Hub</span>, we are driven by a passion to provide the best platform to <strong>play free online games</strong>.
          Our goal is to revolutionize the browser gaming industry by creating a sustainable ecosystem where developers and players connect.
          We strive to build a global community rooted in safety, inclusivity, and pure fun for all our <strong>online games</strong>.
        </p>

        <ul className="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-1 gap-8 mt-10">

          <li data-aos="zoom-in"  data-aos-delay="200" className="h-full group">
            <div className="bg-gray-800 h-full rounded-2xl cursor-pointer shadow-lg p-8 hover:scale-105 transition-transform border border-gray-700 hover:border-blue-500/50" >
              <Target className="text-blue-400 w-14 h-14 mx-auto mb-6 group-hover:rotate-12 transition-transform" />
              <h3 className="text-xl font-bold mb-3 text-white">Our Mission</h3>
              <p className="text-gray-400 text-sm leading-6">
                To democratize gaming by providing free access to high-quality entertainment for everyone, regardless of their device. We aim to remove barriers so anyone can <strong>play free online</strong> instantly.
              </p>
            </div>
          </li>
          

          <li data-aos="zoom-in" data-aos-delay="300" className="h-full group">
             <div className="bg-gray-800 h-full rounded-2xl cursor-pointer shadow-lg p-8 hover:scale-105 transition-transform border border-gray-700 hover:border-yellow-500/50">
                <Telescope className="text-yellow-400 w-14 h-14 mx-auto mb-6 group-hover:-rotate-12 transition-transform" />
                <h3 className="text-xl font-bold mb-3 text-white">Our Vision</h3>
                <p className="text-gray-400 text-sm leading-6">
                  To become the world's leading destination for HTML5 <strong>free browser games</strong>, fostering a creative environment where independent developers thrive and players discover new adventures every day.
                </p>
             </div>
          </li>

          <li data-aos="zoom-in" data-aos-delay="400" className="h-full group">
             <div className="bg-gray-800 h-full rounded-2xl cursor-pointer shadow-lg p-8 hover:scale-105 transition-transform border border-gray-700 hover:border-purple-500/50">
                <HeartHandshake className="text-purple-400 w-14 h-14 mx-auto mb-6 group-hover:scale-110 transition-transform"/>
                <h3 className="text-xl font-bold mb-3 text-white">Our Core Values</h3>
                <p className="text-gray-400 text-sm leading-6">
                   We prioritize <strong>User Experience</strong> and <strong>Digital Safety</strong> above all else. We are committed to maintaining a clean, family-friendly platform free from intrusive ads and harmful content.
                </p>
             </div>
          </li>

        </ul>
      </div>
    </section>
  );
};

export default MissionVision;
